import script from "./FilialProvedorFiscalFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialProvedorFiscalFrame.vue?vue&type=script&setup=true&lang=js"

import "./FilialProvedorFiscalFrame.vue?vue&type=style&index=0&id=dace94ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dace94ce"]])

export default __exports__